module.exports = __webpack_public_path__ + "img/file-upload.90a512e3.svg";